import React, { Component } from 'react';
import {Grid} from "@material-ui/core"; 
import axios from "axios";
import Navbar from "../NAV/Navbar";
import LeftBanner from "./LeftBanner";
import Footer from "./Footer";
import './ViewPost.css';

class ViewPost extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            Post:null,
            title:null,
            author:null,
            date1:null,
            imgUrl:null,
            openingText:null,
            Series:null
         }
    }
    componentDidMount(){
        let tm= this.props.match.params.id.substr(1)
        axios.get("https://know-search-backend.herokuapp.com/getArticles",{params:{time:tm}}).then((res)=>{
            var date=new Date(parseInt(res.data[0].time));
            var date12=date.toDateString();
            console.log(date12);
            this.setState({
                Post:res.data[0].post,
                title:res.data[0].title,
                date:date12,
                author:res.data[0].name,
                imgUrl:res.data[0].imgUrl,
                openingText:res.data[0].openingText,
                Series:res.data[0].Series
            })
        })
    }
    render() { 
        return (
            <Grid container>
                <Navbar/>
                {(this.state.Post)?<Grid item xs={12} style={{marginTop:"5vh"}} container>
                <Grid item md={3} xs={2}></Grid>
                <Grid item md={6} xs={9} container spacing={2}>
                    <Grid item xs={12}>
                        <h5 style={{margin:0}}>{this.state.Series}</h5>
                    </Grid>
                    <Grid item xs={12}>
                    <h2 style={{margin:0}}>{this.state.title}</h2>
                    </Grid>
                    <Grid item xs={12} container spacing={2}>
                        <Grid item xs={2} style={{textAlign:"right"}}>
                        <img className="profileImg" src={this.state.imgUrl}/>
                        </Grid>
                        <Grid xs={10} item>
                            <h5>{this.state.author}</h5>
                            <h6>{this.state.date}</h6>
                        </Grid>
                    </Grid>
                    <Grid item xs={2}></Grid>
                    <Grid item xs={9} style={{color:"#808080"}}>
                        {this.state.openingText}
                    </Grid>
                    <Grid item xs={1}></Grid>
                </Grid>
                <Grid item md={3} xs={12} style={{height:"2vh"}}></Grid>
                <Grid item md={3} xs={12}>
                <LeftBanner />
                </Grid>
                <Grid item md={6} xs={12} style={{marginTop:`5vh`,paddingLeft:'4vw',paddingRight:'4vw'}}
                dangerouslySetInnerHTML={{
                    __html: this.state.Post
                }}></Grid>
                <Grid item md={3} xs={0}></Grid>
                <Grid item xs={12} style={{marginLeft:`30vw`,marginRight:`30vw`,marginBottom:"5vh"}}>
                    <Footer />
                </Grid>
                </Grid>:<Grid item style={{margin:"5vw"}}>Please Wait ...</Grid>}
                
            </Grid>
         );
    }
}
 
export default ViewPost;


// WEBPACK FOOTER //
// ./src/components/VIEW/ViewPost.js